// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"adfe1fdc","291":"75c25150","427":"4f14b93e","606":"5a24b48d","616":"86110c69","960":"0f675616"}[chunkId] + ".chunk.js";
};